/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 12:29:04
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 12:30:49
 * @FilePath: /unifyxp-v2-store-portal/src/tools/hooks/useItemChangeWithOrder/index.ts
 */
import React from 'react';
import _ from 'lodash';

const generateMappedSelectedKeys = (selectedItems = []) => {
  return selectedItems.reduce((pre, now) => {
    return {
      ...pre,
      [now.uuid]: {
        current: false,
        checked: true,
        product: now,
      },
    };
  }, {});
};

const onOkClick = (updateMappedSelectedKeys, onOk, onCancel) => {
  const selectedProducts = Object.values(updateMappedSelectedKeys()).reduce(
    (pre: any, now: any) => {
      if (now.checked) {
        return [...pre, now.product];
      } else {
        return pre;
      }
    },
    [],
  );

  onOk(selectedProducts);
  onCancel();
};

const updateMappedSelectedKeys = (mappedSelectedKeys, selectedRowKeys) => {
  const _keys = _.cloneDeep(mappedSelectedKeys); //{uuid:{}}
  selectedRowKeys.forEach((i) => {
    const { uuid, product } = i;
    if (uuid) {
      if (!_keys[uuid]) {
        _keys[uuid] = { checked: true, current: false }; //不在当前页
      }
      _keys[uuid].checked = true;
      _keys[uuid].product = product;
    }
  });
  Object.keys(_keys).forEach((i) => {
    if (
      _keys[i].current && //_keys ->总表
      _keys[i].checked && //selectedRowKeys->当前页
      !selectedRowKeys.map((i) => i.uuid).includes(i)
    ) {
      _keys[i].checked = false;
      _keys[i].product = null;
    }
    _keys[i].current = false;
  });

  return _keys || {};
};

const onSelectChange = (selections, mappedProducts, setSelectedRowKeys) => {
  const res = selections.map((i) => {
    return {
      uuid: i,
      product: mappedProducts[i],
    };
  });
  setSelectedRowKeys(res);
};

const useProductsHasUpdate = (
  products,
  setMappedSelectedKeys,
  setSelectedRowKeys,
  updateMappedSelectedKeys,
  extraProps?,
) => {
  const { noPagination, keepData } = extraProps || {};
  const update = () => {
    const _keys = updateMappedSelectedKeys();
    //console.log('_keys', _keys);
    ///新的初始化
    const _selected = [];
    (products || []).forEach((product) => {
      const { uuid } = product;

      if (_keys[uuid]) {
        if (_keys[uuid].checked) {
          _selected.push({ uuid, product });
        }
        _keys[uuid].current = true; //如果原来没有选就没有初始化对象
      }
    });
    // for (const product of products) {

    //   }
    // }

    setMappedSelectedKeys(_keys);

    setSelectedRowKeys(_selected);
  };
  // React.useEffect(() => {
  //   update();
  // }, []);
  React.useEffect(() => {
    // if (!noPagination) {
    //   update();
    // }
    update();
    if (noPagination && !keepData) {
      setMappedSelectedKeys({});
    }
  }, [products]);
};

export const useItemsChange = (
  selectedItems, //原来选择的
  products, //当前页面的所有数据
  onOk,
  onCancel,
  extraProps?,
) => {
  const { noPagination, keepData } = extraProps || {};
  const mappedProducts = React.useMemo(() => {
    return products.reduce((pre, now) => {
      return { ...pre, [now.uuid]: now };
    }, {});
  }, [products]);

  const [mappedSelectedKeys, setMappedSelectedKeys] = React.useState<any>(
    generateMappedSelectedKeys(selectedItems),
  );

  //console.log('mappedSelectedKeys', mappedSelectedKeys);

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<any>([]);

  const _updateMappedSelectedKeys = React.useCallback(() => {
    const re = updateMappedSelectedKeys(mappedSelectedKeys, selectedRowKeys);

    return re;
  }, [mappedSelectedKeys, selectedRowKeys]);
  // console.log('mappedSelectedKeys', mappedSelectedKeys);
  // console.log('selectedRowKeys', selectedRowKeys);

  useProductsHasUpdate(
    products,
    setMappedSelectedKeys,
    setSelectedRowKeys,
    _updateMappedSelectedKeys,
    { noPagination, keepData },
  );

  const onOkPress = () => {
    onOkClick(_updateMappedSelectedKeys, onOk, onCancel);
  };

  const _onSelectChange = (selections) => {
    onSelectChange(selections, mappedProducts, setSelectedRowKeys);
  };

  const clearMapKeys = () => {
    setMappedSelectedKeys({});
  };
  //console.log('mappedSelectedKeys', mappedSelectedKeys);
  // console.log('selectedRowKeys', selectedRowKeys);
  return {
    onOk: onOkPress,
    onSelectChange: _onSelectChange,
    selectedRowKeys,
    setSelectedRowKeys,
    clearMapKeys,
  };
};
